import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const NivelRiesgo = "NivelRiesgo";

const ComboNivelRiesgo= (request: Ifilter, controller = new AbortController()) => {
    return fetchListVerificacion.get(`${NivelRiesgo}/Combo`, {
        params: request,
        signal: controller.signal,
    });
};
const NivelRiesgoService = {
    ComboNivelRiesgo
}

export { NivelRiesgoService };